import { render, staticRenderFns } from "./AlertTable.vue?vue&type=template&id=2c16e49d&scoped=true&"
import script from "./AlertTable.vue?vue&type=script&lang=js&"
export * from "./AlertTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertTable.vue?vue&type=style&index=0&id=2c16e49d&prod&lang=scss&scoped=true&"
import style1 from "./AlertTable.vue?vue&type=style&index=1&id=2c16e49d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c16e49d",
  null
  
)

export default component.exports